import * as React from 'react';
import { Helmet } from 'react-helmet';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  EditionsDataProps, EditionsProps, EditionsThemeProps,
  getActiveEdition,
} from '../../components/navigation/header/primaryHeader/Editions';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { DropDownMenu } from '../../components/navigation/header/DropDownMenu';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { ChevronIcon, Directions } from '../../components/navigation/header/ChevronIcon';
import { primaryHeaderHeight } from '../../components/navigation/header/header.utils';

const componentConfigThemeKey = 'editions';

const getStyle = (color:string) => {
  return StyleSheet.create({
    editionsWrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        display: 'none',
      },
    },
    editionsTitleWrapper: {
      height: `${primaryHeaderHeight}px`,
      width: '144px',
      color,
      textDecoration: 'none',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      ':hover': {
        cursor: 'pointer',
      },
    },
    editionsTitle: {
      height: '100%',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
  });
};

export const AMPEditionsComponent:React.FunctionComponent<EditionsProps> = props => {
  const { editions, color, editionEndpoint } = props;
  const activeEdition = getActiveEdition(editions, editionEndpoint);
  const style = getStyle(color);
  return (
    <React.Fragment>
      <Helmet>
        <script async={undefined} custom-element="amp-accordion" src="https://cdn.ampproject.org/v0/amp-accordion-0.1.js" />
      </Helmet>
      <div className={css(style.editionsWrapper)}>
        {/*
  // @ts-ignore TS2339: Property 'amp-accordion' does not exist on type 'JSX.IntrinsicElements'. */}
        <amp-accordion id="accordion-editions" disable-session-states={undefined}>
          <section>
            <h4 className={css(style.editionsTitleWrapper)}>
              <div className={css(style.editionsTitle)}>
                <div>{activeEdition.text}</div>
                <ChevronIcon direction={Directions.DOWN} color={color} />
              </div>
            </h4>
            <DropDownMenu menuLinks={editions} configThemeKey="editionsMenu" activeEndpoint={editionEndpoint} />
          </section>
          {/*
  // @ts-ignore TS2339: Property 'amp-accordion' does not exist on type 'JSX.IntrinsicElements'. */}
        </amp-accordion>
      </div>
    </React.Fragment>
  );
};

const mapThemeProps = (theme: EditionsThemeProps) => {
  return {
    color: theme.color,
  };
};

export const AMPEditions = (props: EditionsDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <ErrorBoundary><AMPEditionsComponent {...themeContext} {...props} /></ErrorBoundary>;
};
